import * as R from 'ramda';
import { jsonDateFormat } from '../../common/constants';
import moment from 'moment';

/**
 * Parsing rest data to our own data structures that
 * will be passed to the views via props
 */

export const mapHistoryRowsFromJson = R.compose(json => {
  return {
    accountId: json['account_id'],
    accountName: json['account_name'],
    date: json['date'],
    transactionDescription: json['transaction_description'],
    cashflowType: json['cashflow_type'],
    cashflowDirection: json['cashflow_direction'],
    cashflowAmount: json['cashflow_amount']
  };
}, R.defaultTo({}));

const minDate = minPeriod => {
  switch (minPeriod) {
    case 'this_week':
      return moment()
        .subtract(7, 'day')
        .startOf('day')
        .format(jsonDateFormat);
    case 'this_month':
      return moment()
        .subtract(1, 'month')
        .startOf('day')
        .format(jsonDateFormat);
    case 'past_three_months':
      return moment()
        .subtract(3, 'month')
        .startOf('day')
        .format(jsonDateFormat);
    default:
      return undefined;
  }
};

export const mapFiltersToJson = R.compose(obj => {
  return {
    account_id: obj['accountId'] || undefined,
    min_date: minDate(obj['minDate']),
    cashflow_direction: obj['cashflowDirection'] || undefined
  };
}, R.defaultTo({}));
